import { ReportFieldInputProps } from "@components/ReportField/types";

export const ReportFieldBlankSignatureLine: React.FC<ReportFieldInputProps> = ({ value }) => {
  return (
    <div className="flex flex-col items-start py-4">
      <div className="w-64 border-b-2 border-black" />
      {value && <span className="ph-no-capture mt-1 text-sm text-text-secondary">{value}</span>}
    </div>
  );
};
